import { useTranslation } from "react-i18next"
import i18n from "../i18n";



export default function QuittingFacebook() {
  const { t } = useTranslation();
  const lang = i18n.language.slice(0, 2);

  return (
    <div className="generic-page">
      <div className="narrow-content">
        <h1>{t('quitting-facebook.title')}</h1>
        <img style={{ maxWidth: '100%' }} 
          src={`/${lang}/quitting_facebook.png`} alt="Quitting Facebook Image" />
        <p><sup>1</sup> <a target="_blank" href="https://www.politico.eu/article/russia-influence-hackers-social-media-facebok-operation-thriving/">&#91;politico.eu&#93;: Russian influence operation thrives on Facebook</a></p>
        <p><sup>2</sup> <a target="_blank" href="https://www.independent.co.uk/tech/facebook-meta-announcement-fact-checking-hate-speech-b2675594.html">&#91;independent.co.uk&#93;: Facebook lifts restrictions on calling women ‘property’ and transgender people ‘freaks’</a></p>
        <p><sup>3</sup> <a target="_blank" href="https://www.cnet.com/news/social-media/facebook-instagram-and-threads-will-stop-fact-checking-as-of-today/">&#91;cnet.com&#93;: Facebook, Instagram Fact-Checking Has Ended: What That Means for You</a></p>
        <p><sup>4</sup> <a target="_blank" href="https://www.eff.org/deeplinks/2025/01/mad-meta-dont-let-them-collect-and-monetize-your-personal-data">&#91;eff.org&#93;: Mad at Meta? Don't Let Them Collect and Monetize Your Personal Data</a></p>
      </div>
    </div>
  )
}

